if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');        
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.currentVariantGroup = null;

        // A standard product is a product which has been created after the initial product import, the carousel was heavily modified to support the imported products with specific fields, then support for more standard product types were required
        const standardProduct = this.elements.viewer.querySelector('[data-is-standard-product]');
        if (standardProduct) {
          this.setActiveMedia(standardProduct.dataset.mediaId);
        }
        if (!this.elements.thumbnails) return;
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        if (!event.detail?.currentElement?.dataset?.mediaId) return;
        
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        if (!thumbnail) return;
        
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        let activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }

        let activeThumbnail;

        if (this.elements.thumbnails) {
          activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          
          // Check if we're switching between variants by comparing variant groups
          if (activeThumbnail && 
              this.currentVariantGroup !== null && 
              this.currentVariantGroup !== activeThumbnail.dataset.variantImageGroup) {
            // get all variant images with a matching data-variant-image-group value 
            const imageGroup = Array.from(this.elements.thumbnails.querySelectorAll(`[data-variant-image-group="${activeThumbnail.dataset.variantImageGroup}"]`));
            // find the default thumbnail within the same variant
            const defaultThumbnail = imageGroup.find((element) => element.dataset.isDefault);
            // set activeThumbnail to the default thumbnail
            activeThumbnail = defaultThumbnail;
            if (activeThumbnail) {
              activeMedia = this.elements.viewer.querySelector(`[data-media-id="${activeThumbnail.dataset.target}"]`);
            }
          }
          
          // Update the current variant group
          if (activeThumbnail) {
            this.currentVariantGroup = activeThumbnail.dataset.variantImageGroup;
          }
        }

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }, 10);

        this.playActiveMedia(activeMedia);
        
        if (!this.elements.thumbnails) return;
        
        if (!activeThumbnail) {
          activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        };
        
        if (!activeThumbnail) return;
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        // remove current attribute
        this.elements.thumbnails.querySelectorAll('button').forEach((element) => {
          element.removeAttribute('aria-current');
        });

        // set the current thumbnail to active
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        // show the current variant thumbs
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((element) => {
          element.classList.add('is-hidden');
          element.classList.remove('is-active');
          if (element.dataset.variantImageGroup === thumbnail.dataset.variantImageGroup) {
            element.classList.add('is-active');
            element.classList.remove('is-hidden');
          }
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
